/* Localize only the Judge.me counter label. Keep ratings and review content intact. */
(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('en')) return;
  const labels = () => document.querySelectorAll('.jdgm-prev-badge__text').forEach((node) => {
    const text = node.textContent.trim();
    const count = text.match(/^([\d\s.,]+)\s+avis$/i);
    if (count) node.textContent = `${count[1]} reviews`;
    else if (/^aucun avis$/i.test(text)) node.textContent = 'No reviews yet';
  });
  labels();
  new MutationObserver(labels).observe(document.body, { childList: true, subtree: true });
})();
